export const isFilledArray = (array: unknown[]) => {
  return array && Array.isArray(array) && array.length > 0;
};
